<script>
  // ---------------------------------------
  // State declarations
  // ---------------------------------------

  export let task;
  export let userAnswer;

  $: ({ rightAnswer } = task);

  let labelClass = "block font-medium font text-sm mb-1";

  // ---------------------------------------
  // Effects
  // ---------------------------------------

  // ---------------------------------------
  // Lifecycle
  // ---------------------------------------

  // ---------------------------------------
  // Component functions
  // ---------------------------------------
</script>

<div class={`open ${$$props.class} flex flex-row align-start`}>
  <div class="mr-4 w-300">
    <span class={labelClass}>La tua risposta</span>
    <span class="block text-base">{userAnswer}</span>
  </div>
  <div class="w-auto w-sm">
    <span class={labelClass}>Risposta consigliata</span>
    <span class="block text-base text-primary-900 font-medium"
      >{task.rightAnswer}</span
    >
  </div>
</div>

<style lang="scss">
  @import "src/shared/theme/theme.scss";
  @import "src/shared/theme/globals.scss";
</style>
